var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70472 15.3868C2.35233 14.7228 0.0983448 12.6422 1.90153 9.63206C2.62285 8.56966 1.60106 6.97604 1 6.31204C1.90159 6.4596 3.74986 6.88751 3.93018 7.41871C3.85504 5.64803 4.24573 1.88534 6.40956 1C6.48469 3.58224 6.95051 8.61392 8.21274 8.08272C9.47497 7.55152 10.1034 6.30039 10.1034 4.02879C11.2414 5.16459 11.5 9.4856 11.5 11C11.5 12.4002 10.3963 14.9246 7.82759 15.7654C6.47569 16.2079 4.6547 15.9925 3.70472 15.3868Z",
    fill: "#EC6500",
    stroke: "#D41D3C",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.e7455ba4e4b1d66e4a875e286b73af9e.svg";
export { ForwardRef as ReactComponent };